
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lng]/referrals-mechanism",
      function () {
        return require("private-next-pages/[lng]/referrals-mechanism.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lng]/referrals-mechanism"])
      });
    }
  